<div class="login-container">
    <div></div>

    <div class="login-content">
        <div>
            <img src="../../../assets/img/login.png" class="img-fluid img" />
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" *ngIf="!isLoading" class="form-login">
            <h2 class="h2-login login-padding-top-20">CloudFlow Evidence</h2>
            <ul class="login-padding-bottom-20">
                <li>{{ 'home.cardInvoice.paragraph-1' | translate }}</li>
                <li>{{ 'home.cardTransport.paragraph-1' | translate }}</li>
            </ul>

            <kendo-formfield>
                <kendo-label [for]="username" text="{{ 'login.fieldUsername' | translate }}"> </kendo-label>
                <kendo-textbox formControlName="username" #username [clearButton]="true" required> </kendo-textbox>
                <kendo-formerror>{{ 'login.errorUsername' | translate }}</kendo-formerror>
            </kendo-formfield>
            <kendo-formfield>
                <kendo-label [for]="password" text="{{ 'login.fieldPassword' | translate }}"></kendo-label>
                <kendo-textbox formControlName="password" #password [clearButton]="true" required>
                    <ng-template kendoTextBoxSuffixTemplate>
                        <button kendoButton look="clear" type="button" icon="eye" (click)="toggleVisibility()"></button>
                    </ng-template>
                </kendo-textbox>
                <kendo-formerror>{{ 'login.errorPassword' | translate }}</kendo-formerror>
            </kendo-formfield>

            <kendo-label *ngIf="error" class="k-form-error login-error" [text]="error"></kendo-label>

            <div class="k-form-buttons" style="justify-content: center">
                <button kendoButton class="k-button k-button-md k-rounded-md k-button-rectangle" type="submit">
                    <i *ngIf="loading" class="fas fa-sync fa-spin"></i>
                    <i *ngIf="!loading" class="fas fa-sign-in-alt"></i>
                    {{ 'login.loginBtn' | translate }}
                </button>
                <button kendoButton class="k-button k-button-md k-rounded-md k-button-rectangle" (click)="clearForm()">
                    {{ 'login.clear' | translate }}
                </button>
            </div>
        </form>
    </div>
</div>

<br />
<br />
